import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, Phone, Check } from "lucide-react";
import { api, dateTR, formatApiError } from "@/lib/api";

export default function Messages() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/contact").then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { try { await api.put(`/contact/${id}/read`); load(); } catch (e) { toast.error(formatApiError(e)); } };
  const remove = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/contact/${id}`); load(); };

  return (
    <div data-testid="messages-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">İletişim</p>
      <h1 className="mt-2 font-display font-extrabold tracking-tighter text-4xl md:text-5xl">Gelen Mesajlar</h1>

      <div className="mt-8 space-y-3">
        {items.length === 0 ? (
          <div className="border border-dashed border-white/10 p-12 text-center text-white/45 font-mono text-xs uppercase tracking-[0.3em]">Mesaj yok</div>
        ) : items.map((m) => (
          <article key={m.id} className={`border bg-[#121212] p-5 ${m.read ? "border-white/8" : "border-[#d4af37]/40"}`} data-testid={`message-${m.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-3">
                  <span className="font-display text-xl text-white">{m.name}</span>
                  {!m.read && <span className="text-[10px] font-mono uppercase tracking-[0.3em] bg-[#d4af37]/15 border border-[#d4af37]/30 text-[#d4af37] px-2 py-0.5">Yeni</span>}
                  {m.subject && <span className="text-[10px] font-mono uppercase tracking-[0.3em] border border-white/15 text-white/55 px-2 py-0.5">{m.subject}</span>}
                </div>
                <div className="flex items-center flex-wrap gap-3 mt-1 text-xs text-white/55">
                  {m.email && <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1 hover:text-[#d4af37]"><Mail className="h-3 w-3" /> {m.email}</a>}
                  {m.phone && <a href={`tel:${m.phone}`} className="inline-flex items-center gap-1 hover:text-[#d4af37]"><Phone className="h-3 w-3" /> {m.phone}</a>}
                  <span className="font-mono text-white/35">{dateTR(m.created_at)}</span>
                </div>
                <p className="mt-3 text-white/75 whitespace-pre-wrap">{m.message}</p>
              </div>
              <div className="flex items-center gap-2">
                {!m.read && <button onClick={()=>markRead(m.id)} className="p-2 text-white/40 hover:text-[#d4af37]" title="Okundu"><Check className="h-4 w-4" /></button>}
                <button onClick={()=>remove(m.id)} className="p-2 text-white/40 hover:text-[#d4af37]"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
